export default __webpack_public_path__ + "static/media/note-active.697f3fd1.svg";